module.exports = __webpack_public_path__ + "img/a9_07.50f7baa9.jpg";